import { cn } from '@cannect/lib/utils'
import { HTMLAttributes } from 'react'

function Skeleton({ className, full, ...props }: HTMLAttributes<HTMLDivElement> & { full?: boolean }) {
  return <div className={cn(`${full ? 'size-full' : ''} animate-pulse rounded bg-gray-100`, className)} {...props} />
}

export { Skeleton }
